import Icon from '@/components/snippets/icon/icon'

export function FilterCollapse({ label, children }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  return (
    <x-modal data-id={`filter-${id}`} className="flex flex-col border-b group/filter border-brand-pink">
      <button
        className="flex items-center justify-between gap-x-0.75 lg-max:px-margin py-1 link-fade"
        data-modal-parent={`filter-${id}`}
        data-modal-role="toggle"
        aria-label={label}
      >
        <span className="paragraph-b font-medium">{label}</span>
        <div className={'flex w-[14px] h-[8px] group-data-visible/filter:-rotate-180 transition-all children:size-full'}>
          <Icon id="chevron-down" />
        </div>
      </button>
      <div className="flex flex-col gap-1.5 max-h-0 opacity-0 overflow-hidden group-data-visible/filter:opacity-100 group-data-visible/filter:max-h-[150vh] group-data-visible/filter:opacity-100 transition-all">
        {children}
      </div>
    </x-modal>
  )
}
